import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumDataImportTimestampFormat implements BaseEnumType {
  private static allValues: EnumDataImportTimestampFormat[] = []; // make sure this is top-most
  
  public static none = new EnumDataImportTimestampFormat(0, "None", "enum_data_import_timestamp_format_none");
  public static iso8601_2019 = new EnumDataImportTimestampFormat(1, "Iso8601_2019", "enum_data_import_timestamp_format_iso8601_2019");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumDataImportTimestampFormat.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isNone() { return this === EnumDataImportTimestampFormat.none; }
  public isIso8601_2019() { return this === EnumDataImportTimestampFormat.iso8601_2019; }

  public static getValues(): readonly EnumDataImportTimestampFormat[] {
    return EnumDataImportTimestampFormat.allValues;
  }

  public static getValuesExcept0(): readonly EnumDataImportTimestampFormat[] {
    return EnumDataImportTimestampFormat.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumDataImportTimestampFormat {
    const found = EnumDataImportTimestampFormat.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumDataImportTimestampFormat - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumDataImportTimestampFormat): EnumDataImportTimestampFormat {
    const found = name ? EnumDataImportTimestampFormat.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumDataImportTimestampFormat - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumDataImportTimestampFormat>): boolean {
    return this.key === other?.key;
  }
}